import { useAuth } from '@/store/auth'

export const authRoutes = [
  {
    path: '/auth',
    component: () => import('@/layouts/login/Index.vue'),
    children: [
      {
        path: 'login',
        alias: '',
        name: 'Login',
        component: () => import('@/components/auth/LoginForm.vue'),
      },
      {
        path: 'logout',
        name: 'Logout',
        beforeEnter: () => useAuth().logout(),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: 'login/:token',
        name: 'LoginByToken',
        component: () => import('@/components/auth/LoginToken.vue'),
        meta: {
          requireAuth: null,
        },
      },
      {
        path: 'forgot',
        name: 'ForgotPassword',
        component: () => import('@/components/auth/ForgotPassword.vue'),
      },
      {
        path: '/reset-password/:token',
        component: () => import('@/components/auth/SetNewPassword.vue'),
      },
    ],
    meta: {
      requireAuth: false,
    },
  },
]
